import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const UserPreferencesViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
UserPreferencesViewTopBar.displayName = "UserPreferencesViewTopBar"
